import axios from '@/api/http';
import base from '@/api//base';
const login = {
  // 登录
	loginFun(params){
		return axios.post(`${base.baseURL}/auth/login`,{username: params.username, password: params.password});
	},
	getUserInfo(){
		return axios.get(`${base.baseURL}/auth/getUserInfo`);
	}
}
export default login;



// WEBPACK FOOTER //
// ./src/network/login.js